import { Alert, Divider, Skeleton } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import gql from 'graphql-tag';
import { useAuthedQuery } from 'utils/qlAuth';

export const UniverseRunwaymlVideoAutomation = (props: { universeId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query UniverseController_getRunwaymlVideoAutomation_Robot($universeId: Int!) {
        UniverseController_getRunwaymlVideoAutomation_Robot(universeId: $universeId)
      }
    `,
    {
      variables: { universeId: Number(props.universeId) },
    },
  );

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const jsonStringRobot = qFrames.data?.UniverseController_getRunwaymlVideoAutomation_Robot;
  return (
    <>
      <Alert message="RunwayML Video Automation" description={<>Universe automation</>} type="info" showIcon style={{ marginBottom: '16px' }} />
      <TextArea rows={30} value={jsonStringRobot} />
    </>
  );
};
